/*
 * @Author: Kuiper
 * @Date: 2021-06-24 19:37:19
 */
import { App } from 'vue'

/**
 * 注册全局方法
 * @param app
 */
export function setupGlobalMethods(app: App) {
  // TODO
  console.log('setupGlobalMethods', app)
}
